import React from 'react'
import autobind from 'auto-bind'
import PropTypes from 'prop-types'
import Tree from 'rc-tree'
import 'rc-tree/assets/index.css'
import {getTreeFromFlatData} from 'react-sortable-tree'

class ModelTree extends React.Component {
    constructor(props) {
        super(props)
        autobind(this)

        this.flatData = []
        this.treeData = []

        this.makeFieldList({model: this.props.dataModel})

        this.flatData = this.flatData.map((f) => {
            if (
                f.type === 'MultiSubModel' ||
                f.type === 'SingleSubModel' ||
                f.type === 'ForeignID'
            )
                f.icon = <i className="iconsmind-Folder" />
            else f.icon = <i className="iconsmind-Right-2" />
            return f
        })
        this.treeData = getTreeFromFlatData({
            flatData: this.flatData,
            getKey: (node) => node.key,
            getParentKey: (node) => node.parentFieldId,
            rootKey: null,
        })
    }

    makeFieldList({
        model,
        parentFieldId,
        parentFieldName,
        referenceDataModelId = false,
        referenceId = false,
        referenceDepth = 0,
        parentReferences = [],
        manualDataLinkRootModel = null,
        rootDataModelId = null,
    }) {
        let references = model.references || []
        if (references.length && !this.props.includeJoins) references = []

        if (!model.parentDataModelId && !manualDataLinkRootModel) {
            rootDataModelId = model._id
        }

        if (
            this.props.showMap({type: 'UniqueID'}) &&
            !model.parentDataModelId
        ) {
            this.flatData.push({
                model: manualDataLinkRootModel || model,
                key: parentFieldId ? parentFieldId + '.' + '_id' : '_id',
                path: parentFieldName ? parentFieldName + '.' + '_id' : '_id',
                parentFieldId: parentFieldId || null,
                title: 'Row ID (auto-generated)',
                type: 'UniqueID',
                field: {},
                referenceDataModelId,
                referenceId,
                referenceDepth,
                parentReferences,
                rootDataModelId,
            })
        }

        if (
            !model.parentDataModelId &&
            (model.modelType === 'State' || model.modelType === 'Event') &&
            this.props.showMap({type: 'RegularizedTimestamp'})
        ) {
            this.flatData.push({
                model: manualDataLinkRootModel || model,
                key: parentFieldId ? parentFieldId + '.' + 'time' : 'time',
                path: parentFieldName
                    ? parentFieldName + '.' + '@@time@@'
                    : '@@time@@',
                parentFieldId: parentFieldId || null,
                title: 'Time (auto-generated)',
                type: 'RegularizedTimestamp',
                field: {},
                referenceDataModelId,
                referenceId,
                referenceDepth,
                parentReferences,
                rootDataModelId,
            })
        }
        if (
            !model.parentDataModelId &&
            model.modelType === 'State' &&
            this.props.showMap({type: 'RegularizedDuration'})
        ) {
            this.flatData.push({
                model: manualDataLinkRootModel || model,
                dataModelId: model._id,
                key: parentFieldId
                    ? parentFieldId + '.' + 'duration'
                    : 'duration',
                path: parentFieldName
                    ? parentFieldName + '.' + '@@duration@@'
                    : '@@duration@@',
                parentFieldId: parentFieldId || null,
                title: '__Duration_Minutes__',
                type: 'RegularizedDuration',
                field: {},
                referenceDataModelId,
                referenceId,
                referenceDepth,
                parentReferences,
            })
        }

        for (let field of model.fields.filter((f) => !f.archived)) {
            if (this.props.showMap(field)) {
                for (let join of references) {
                    let referencedModel = this.props.dataModels.find(
                        (m) => m._id === join.targetDataModelId
                    )
                    if (
                        !this.flatData.find(
                            (a) =>
                                a.key ===
                                (parentFieldId
                                    ? parentFieldId + '.' + referencedModel.name
                                    : referencedModel.name)
                        )
                    ) {
                        this.flatData.push({
                            model: manualDataLinkRootModel || model,
                            dataModelId: model._id,
                            key: parentFieldId
                                ? parentFieldId + '.' + referencedModel.name
                                : referencedModel.name,
                            path: parentFieldName
                                ? parentFieldName + '.' + referencedModel.name
                                : referencedModel.name,
                            parentFieldId: parentFieldId || null,
                            title: join
                                ? referencedModel.name + ' (reference)'
                                : referencedModel.name,
                            type: field.type,
                            field,
                            referenceDataModelId,
                            referenceId,
                            referenceDepth,
                            parentReferences,
                            rootDataModelId,
                        })

                        this.makeFieldList({
                            model: referencedModel,
                            parentFieldId:
                                (parentFieldId ? parentFieldId + '.' : '') +
                                referencedModel.name,
                            parentFieldName: this.props.excludeJoinPrefixes
                                ? parentFieldName
                                : parentFieldName
                                ? parentFieldName + '.' + referencedModel.name
                                : referencedModel.name,
                            referenceDataModelId: model._id,
                            referenceId: join._id,
                            referenceDepth: referenceDepth + 1,
                            parentReferences: referenceId
                                ? parentReferences.concat([
                                      {
                                          referenceId,
                                          dataModelId: referenceDataModelId,
                                          parentFieldId,
                                          referenceDepth,
                                          model,
                                      },
                                  ])
                                : parentReferences,
                            manualDataLinkRootModel,
                        })
                    }
                }
                this.flatData.push({
                    model: manualDataLinkRootModel || model,
                    dataModelId: model._id,
                    key: parentFieldId
                        ? parentFieldId + '.' + field._id
                        : field._id,
                    path: parentFieldName
                        ? parentFieldName + '.' + field.name
                        : field.name,
                    parentFieldId: parentFieldId || null,
                    title: field.name,
                    type: field.type,
                    field,
                    referenceDataModelId,
                    referenceId,
                    referenceDepth,
                    parentReferences,
                    rootDataModelId,
                })
            }
        }

        model.fields
            .filter(
                (f) =>
                    !f.archived &&
                    (f.type === 'MultiSubModel' || f.type === 'SingleSubModel')
            )
            .forEach((f) => {
                const subModel = this.props.dataModels.find(
                    (m) => m.parentFieldId === f._id
                )
                this.makeFieldList({
                    model: subModel,
                    parentFieldId:
                        (parentFieldId ? parentFieldId + '.' : '') + f._id,
                    parentFieldName:
                        (parentFieldName ? parentFieldName + '.' : '') + f.name,
                    referenceDataModelId: referenceDataModelId,
                    referenceId,
                    referenceDepth,
                    parentReferences,
                    manualDataLinkRootModel,
                    rootDataModelId,
                })
            })

        model.fields
            .filter((f) => !f.archived && f.type === 'ForeignID')
            .forEach((f) => {
                const foreignModel = this.props.dataModels.find(
                    (m) => m._id === f.foreignDataModelId
                )
                if (
                    !(
                        manualDataLinkRootModel &&
                        manualDataLinkRootModel.name === model.name &&
                        model.name === foreignModel.name
                    )
                ) {
                    this.makeFieldList({
                        model: foreignModel,
                        parentFieldId:
                            (parentFieldId ? parentFieldId + '.' : '') + f._id,
                        parentFieldName:
                            (parentFieldName ? parentFieldName + '.' : '') +
                            f.name,
                        referenceDataModelId: referenceDataModelId,
                        referenceId,
                        referenceDepth,
                        parentReferences,
                        manualDataLinkRootModel: model,
                        rootDataModelId,
                    })
                }
            })
    }

    render() {
        return (
            <>
                {this.flatData.length ? (
                    <>
                        <Tree
                            onSelect={this.props.onSelect}
                            className="filter-tree"
                            showLine
                            treeData={this.treeData}
                        />
                    </>
                ) : null}
            </>
        )
    }
}

ModelTree.propTypes = {
    height: PropTypes.number,
    onSelect: PropTypes.func,
    dataModels: PropTypes.array,
    dataModel: PropTypes.object,
    showMap: PropTypes.func,
    includeJoins: PropTypes.bool,
    excludeJoinPrefixes: PropTypes.bool,
}

export default ModelTree
